import { Solution } from '@energiebespaarders/constants';
import { Medium } from '@energiebespaarders/symbols/helpers';
import {
  ChatAlertAlt,
  ClipboardCheck,
  FileEuro,
  Shield,
  WrenchScrewdriver,
} from '@energiebespaarders/symbols/icons/solid';
import { QuoteInfoAccordion } from '../utils';
import { debWarranty, insulationCertificationWarranty } from './constants';

export const floorInsulationInfoAccordions = (
  needsPtc: boolean,
  certification: 'insula' | 'skg' = 'skg',
  needsPrepayment: boolean,
): QuoteInfoAccordion[] => [
  {
    key: 'feasibility',
    title: 'Technische haalbaarheid en volledigheid',
    paragraphs: [
      'Deze offerte is geldig onder voorbehoud van technische haalbaarheid en volledigheid. Dit betekent dat er een technische controle nodig is, waarna de nog mutaties kunnen plaatsvinden, afhankelijk van eventuele complicaties en/of meerwerk.',
      'De opdracht is voorgelegd aan een van onze installateurs. Die zal na akkoord bepalen of er nog een technische controle nodig is voordat de installatie kan worden gepland. Bij vloerisolatie wordt bijvoorbeeld gekeken naar de toegankelijkheid en staat van de kruipruimte.',
    ],
    icon: ClipboardCheck,
    hide: !needsPtc,
  },
  {
    key: 'warranty',
    title: 'Installatiegarantie en service',
    paragraphs: [
      insulationCertificationWarranty(Solution.FloorInsulation, certification),
      debWarranty,
    ],
    icon: Shield,
  },
  {
    key: 'invoicing',
    title: 'Facturatie',
    paragraphs: [
      ...(needsPrepayment
        ? [
            <p key="floor-invoicing-0">
              <Medium>Aanbetaling:</Medium> 25% van het totale offertebedrag wordt na het accepteren
              van de definitieve offerte {needsPtc ? '(dus na de technische controle) ' : ''}in
              rekening gebracht.
            </p>,
            <p key="floor-invoicing-1">
              <Medium>Facturatie:</Medium> 75% van het totale offertebedrag na oplevering.
            </p>,
          ]
        : [
            <p key="floor-invoicing-1">
              <Medium>Facturatie:</Medium> het totale offertebedrag na oplevering.
            </p>,
          ]),
      <p key="floor-invoicing-2">
        <Medium>Betalingstermijn:</Medium> binnen 7 dagen na factuurdatum.
      </p>,
      <p key="floor-invoicing-3">
        <Medium>Uitvoering:</Medium> in overleg, na ontvangst opdracht. Als u de opdracht wilt
        annuleren, zijn hier mogelijk kosten aan verbonden.
      </p>,
    ],
    icon: FileEuro,
  },

  {
    key: 'activities',
    title: 'Montage en coördinatie',
    paragraphs: [
      <p key="floor-activities-1">
        De werkzaamheden bij het isoleren van de kruipruimte omvatten in hoofdzaak:
      </p>,
      <ul key="floor-activities-2">
        <li>
          Het aanbrengen van het isolatiemateriaal in de kruipruimte, daar waar deze bereikbaar is
          om de werkzaamheden uit te kunnen voeren;
        </li>
        <li>Het netjes achterlaten van de werkplek.</li>
      </ul>,
      <p key="floor-activities-3">
        Indien niet anders vermeld, zijn de volgende werkzaamheden{' '}
        <Medium>niet in deze offerte opgenomen</Medium>:
      </p>,
      <ul key="floor-activities-4">
        <li>Het verwijderen van puin of grote obstakels;</li>
        <li>Het bereikbaar maken van (thans onbereikbare delen van) de kruipruimte;</li>
        <li>Het afvoeren van oude isolatie, puin of obstakels.</li>
      </ul>,
    ],
    icon: WrenchScrewdriver,
  },
  {
    key: 'reminders',
    title: 'Let ook hierop',
    paragraphs: [
      <p key="floor-reminders-1">
        Er zijn een aantal aandachtspuntjes voor u als bewoner om de uitvoer zo soepel mogelijk te
        laten verlopen:
      </p>,
      <ul key="floor-reminders-2">
        <li>De bewoner draagt zorg voor een vrije parkeerplaats bij de woning;</li>
        <li>De kruipruimte toegankelijk, droog en puinvrij te zijn op de dag van uitvoering;</li>
        <li>
          De bewoner draagt zorg voor een goede bereikbaarheid van de te behandelen oppervlakte.
          Eventuele bosschages, bouwkundige belemmeringen, plantenbakken en/of opgeslagen voorraden
          dienen verwijderd te worden, zodat de uitvoerders vrije toegang hebben tot de te
          behandelen oppervlakte.
        </li>
      </ul>,
    ],
    icon: ChatAlertAlt,
  },
];
